import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import {Container} from 'react-bootstrap';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactTooltip from "react-tooltip";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
// import ToolkitProvider, { ColumnToggle } from 'react-bootstrap-table2-toolkit';

import BidirectionChangeAndCumulativeChart from '../charts/BidirectionChangeAndCumulativeChart';
import DataUtils from '../util/DataUtils';
import ValColumnSelector from "../validators/ValColumnSelector";
import UITableUtils from "../util/UITableUtils";
import MultiLineChart from '../charts/MultiLineChart';
import tooltips from "../tooltips";

import "../validators/Validators.css";
import '../styles/section.css';
import '../styles/tables.css';
import '../styles/validator.css';
import Utilities from "../util/Utilities";
import RespUtils from "../util/RespUtils";

import MainUtils from "../main/MainUtils";
import CoinUtils from '../util/CoinUtils';
import currentNetwork from '../currentNetwork';
import SessionUtils from '../util/SessionUtils';
import ApiUtils from '../util/ApiUtils';
import Loading from '../components/Loading';
import NetworkHeader from '../network/NetworkHeader';
import LSProviders from './LSProviders';
import LSUtils from './LSUtils';
import ValidatorUtils from '../validators/ValidatorUtils';

const key = "lsv_2";

class LSM extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validators: [],
      lsHistory: [],
      notification: {"message": null},
      providers: [],
      frequencyNetwork: "M",
      lspSummary: null,
      lsp: null,
      lspTitle: "",
      lspTitleMobile: "",
      frequency: "M",
      // showAll: false,
      lspDetails: null,
      lastUpdated: "",
      isLoading: true,
      width: window.innerWidth,
    };
    this.updateDimensions = this.updateDimensions.bind(this);
    this.handleChartUpdateNetwork = this.handleChartUpdateNetwork.bind(this);   
    this.repaintData = this.repaintData.bind(this);
    this.getInitColumns = this.getInitColumns.bind(this);
    // this.renderSwitch = this.renderSwitch.bind(this);
    this.switchProtocol = this.switchProtocol.bind(this);
    this.renderFilters = this.renderFilters.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    SessionUtils.initNetwork(this, false);
    let lsp = currentNetwork.details.app.token;
    if (this.props.match && this.props.match.params.lsp) {
      lsp = this.props.match.params.lsp;
    }
    // let showAll = this.state.showAll;
    // await this.prepareData(this.state.frequencyNetwork, showAll, lsp, true);
    await this.prepareData(this.state.frequencyNetwork, lsp);
  }

  // async prepareData(frequencyNetwork, showAll, lsp) {
  async prepareData(frequencyNetwork, lsp) {
    // this.setState({isLoading: true});

    // let url = "listData?type=lsValidators&frequencyNetwork=" + frequencyNetwork + "&loadAll=" + loadAll;
    let url = "listData?type=lsValidators&frequencyNetwork=" + frequencyNetwork;

    let lspTitle = " Overall for $" + currentNetwork.details.app.token;
    let lspTitleMobile = "Overall";
    // if (this.props.match && this.props.match.params.showAll) {
    //   showAll = this.props.match.params.lsp;
    // }
    // url += "&showAll=" + showAll + "&lsp=" + lsp;
    url += "&lsp=" + lsp;
  
    // console.log(url);

    const allData = await ApiUtils.get(url);
    // console.log(allData);
    if (!allData) {
      this.setState({error: true, isLoading: false});
      return;
    }

    let validators = ValidatorUtils.prepValidators(allData["data"]);
    let notification = allData["notification"];
    let coinStat = allData["coinStat"];
  
    let lspDetails = allData["lspDetails"];
    let lsHistory = DataUtils.addCumulativeData(allData["lsHistory"], "deltaDelegation", "cumulativeDelegationChange");
    
    if (lsp != currentNetwork.details.app.token) {
      lspTitle = "via " + lspDetails["name"];
      lspTitleMobile = lspTitle;
    }

    this.setState({"validators": validators, "notification": notification, "coinStat": coinStat, 
      "lsp": lsp, "lspTitle": lspTitle, "lspTitleMobile": lspTitleMobile,
      "frequencyNetwork": frequencyNetwork, "lspSummary": allData["lspSummary"],
      "providers": allData["lsps"], "lsHistory": lsHistory, "lspDetails": lspDetails,
      "isLoading": false});
  }
  
  render() {
    if (this.state.isLoading) {
      return <Loading />;
    }

    const headerSortingClasses = (column, sortOrder, isLastSorting, colIndex) => (
      sortOrder === 'asc' ? 'sorting-asc' : 'sorting-desc'
    );
    
    let token = currentNetwork.details.app.token;

    var columns = [
      {text: "#", desc: "Index", hidden: this.isHidden("index"), dataField: "index", sort: true, align: "left", headerStyle: Utilities.respWidth(7, 5, 4), headerSortingClasses},
      {text: "VP Rank", desc: "VP Rank", hidden: this.isHidden("vpRank"), dataField: "vpRank", sort: true, align: "left", headerStyle: Utilities.respWidth(5, 5, 4), headerSortingClasses},
      {text: "", filter: textFilter({placeholder: "Name"}), desc: "Validator Name", hidden: this.isHidden("name"), dataField: "name", formatter: MainUtils.nameFormatterTableWithLogo, sort: true, headerStyle: Utilities.respWidth(50, 25, 15), headerSortingClasses},
      {text: "Badges",  desc: "Badges", hidden: this.isHidden("badge1Ind"), dataField: "badge1Ind", formatter: MainUtils.formatLSMBadges, sort: true, headerStyle: Utilities.respWidth(15, 15, 6), headerSortingClasses},
      {text: "Status",  desc: "Validator Status", hidden: this.isHidden("status"), dataField: "status", formatter: MainUtils.statusFormatter, sort: true, headerStyle: Utilities.width(9), headerSortingClasses},
      {text: "Voting Power (VP)",  desc: ("Total " + token + " Staked with validator"), hidden: this.isHidden("votingPower"), dataField: "votingPower", formatter: CoinUtils.stakeFormatterRoundIfNeeded, sort: true, headerStyle: Utilities.width(10), headerSortingClasses},
      {text: "% Voting Power",  desc: "% of total voting power that is with the validator", hidden: this.isHidden("votingPowerPercentage"), dataField: "votingPowerPercentage", formatter: MainUtils.percentFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(20, 12, 10), headerSortingClasses},
      {text: "Self Delegation",  desc: ("Total " + token + " Staked by the validator"), hidden: this.isHidden("selfBond"), dataField: "selfBond", formatter: CoinUtils.stakeFormatterRoundIfNeeded, sort: true, headerStyle: Utilities.width(10), headerSortingClasses},
      {text: "Self Delegation %",  desc: "% of total voting power that is self staked by the validator", hidden: this.isHidden("selfBondPercentage"), dataField: "selfBondPercentage", formatter: MainUtils.percentFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10), headerSortingClasses},
      {text: Utilities.respLabel("Comm", "Comm", "Commission"), desc: "Current commission charged by validator", hidden: this.isHidden("commission"), dataField: "commission", formatter: MainUtils.getCommission, style: MainUtils.commissionStyleFormatter, sort: true, headerStyle: Utilities.respWidth(20, 12, 7), headerSortingClasses},
      {text: Utilities.respLabel("Val Bond", "Current Validator Bond", "Current Validator Bond"),  desc: ("Current validator bond for the validator"), hidden: this.isHidden("valBond"), dataField: "valBond", formatter: CoinUtils.stakeFormatterRoundIfNeeded, sort: true, headerStyle: Utilities.respWidth(15, 15, 7), headerSortingClasses},
      {text: "Minimum Validator Bond",  desc: ("Min validator bond to maintain LS delegations"), hidden: this.isHidden("minValBond"), dataField: "minValBond", formatter: CoinUtils.stakeFormatterRoundIfNeeded, sort: true, headerStyle: Utilities.width(7), headerSortingClasses},
      {text: "LSM Delegations",  desc: ("Total LSM Delegations"), hidden: this.isHidden("lsmDelegations"), dataField: "lsmDelegations", formatter: CoinUtils.stakeFormatterRoundIfNeeded, sort: true, headerStyle: Utilities.width(7), headerSortingClasses},
      {text: "Remaining LSM Capacity",  desc: ("Remaining LSM Capacity"), hidden: this.isHidden("valBondRemCapacity"), dataField: "valBondRemCapacity", formatter: LSUtils.formatValBondRemCapacity, sort: true, headerStyle: Utilities.width(7), headerSortingClasses},
      {text: Utilities.respLabel("Enough Bond?", "Does Val Bond Cover Delegation?", "Does Val Bond Cover Delegation?"),  desc: ("Does validator bond cover LSM delegations?"), hidden: this.isHidden("hasEnoughValBond"), dataField: "hasEnoughValBond", formatter: LSUtils.formatHasSufficientValBondInd, sort: true, headerStyle: Utilities.respWidth(15, 15, 7), headerSortingClasses},
      {text: "Stride Delegation",  desc: ("Stride Delegation"), hidden: this.isHidden("strdDelegation"), dataField: "strdDelegation", formatter: CoinUtils.stakeFormatterRoundIfNeeded, sort: true, headerStyle: Utilities.width(7), headerSortingClasses},
      {text: "pSTAKE Delegation",  desc: ("pSTAKE Delegation"), hidden: this.isHidden("pstakeDelegation"), dataField: "pstakeDelegation", formatter: CoinUtils.stakeFormatterRoundIfNeeded, sort: true, headerStyle: Utilities.width(7), headerSortingClasses},
      {text: "Quicksilver Delegation",  desc: ("Quicksilver Delegation"), hidden: this.isHidden("qckDelegation"), dataField: "qckDelegation", formatter: CoinUtils.stakeFormatterRoundIfNeeded, sort: true, headerStyle: Utilities.width(7), headerSortingClasses},
    ];

    let title4TotalLSChart = "Liquid Stake History - " + this.state.lspTitle;
    let title4DeltaLSChart = "Liquid Staking Daily Changes - " + this.state.lspTitle;
    if (RespUtils.isMobileView()) {
      title4TotalLSChart = "LS History - " + this.state.lspTitleMobile;
      title4DeltaLSChart = "LS Delta - " + this.state.lspTitleMobile;
    }

    return (
      <div>
        <NetworkHeader skipStats={true} coinStat={this.state.coinStat} 
          title={"Liquid Staking Delegations ($" + currentNetwork.details.app.token + ")"} 
          shortTitle={"Liquid Staking"} 
          thisObj={this} beta={false} />
        <p/>
        {/* <LSProviders providers={this.state.providers} summary={this.state.lspSummary} showAll={this.state.showAll} switchProtocol={this.switchProtocol} /> */}
        <LSProviders providers={this.state.providers} summary={this.state.lspSummary} coinStat={this.state.coinStat} 
          switchProtocol={this.switchProtocol} selectedProtocol={this.state.lsp}/>
        <ReactTooltip id="main" place="top" type="dark" effect="float" multiline={true} />
        <Container fluid className="containerLayout container-fluid chartContainer">
          <div className="chartGridContainer">
            <div className="chartBg" id="networkSignHistory">
              <MultiLineChart title={title4TotalLSChart} xAxis="Date" yAxis="Total Liquid Stake" adjustRange={true} 
                  showVerticalLabel={false} valueAttr={["totalDelegation"]} rangeAttr="totalDelegation" showTotalLabel={false} xAxisValueAttr="title"
                  data={this.state.lsHistory} tip={tooltips.networkCharts.liquidStakingHistory} hideFullScreenLink={true}
                  handleChart={this.handleChartUpdateNetwork} formatValues={true} fsElementId="liquidStakingHistory" 
                  frequencies={["M", "Y", "All"]} frequency={this.state.frequencyNetwork} />
            </div>
            <div className="chartBg">
              <BidirectionChangeAndCumulativeChart title={title4DeltaLSChart}
                  xAxis="Date" yAxis="Daily LS Changes" xAxisValueAttr="title" cumulativeAttr="cumulativeDelegationChange"
                  valueAttr="deltaDelegation" showVerticalLabel={false} hideFullScreenLink={true}
                  showLegend={true} adjustRange={true}
                  range={[0,3]} data={this.state.lsHistory} tip={tooltips.networkCharts.liquidStakingDeltaHistory} 
                  handleChart={this.handleChartUpdateNetwork} formatValues={true} frequencies={["M", "Y", "All"]} frequency={this.state.frequencyNetwork} 
                  />
            </div>
          </div>
        </Container>
        <br/>
        <ToolkitProvider keyField="poolId" data={this.state.validators} columns={columns} columnToggle>
          {
            props => (
              <div id="mainTable">
                <div className="pageTitle">Liquid Staking Validators</div>
                <ValColumnSelector settingKey={key} getInitColumns={this.getInitColumns}
                  { ...props.columnToggleProps } refreshParent={this.repaintData} 
                  fsElementId="mainTable" hideFullScreenLink={true} renderFilters={this.renderFilters} />
                <BootstrapTable { ...props.baseProps } 
                    filter={ filterFactory() }
                    condensed noDataIndication="No Data" />
              </div>
            )
          }
        </ToolkitProvider>
        <p/>
        <p>This page is updated every 5 minutes. 
          For more information, visit <a className="animLinkVisual" href="https://docs.google.com/document/d/1IqPY4suMZl6Htsu52bwgqr3arGiisU_QfArJa1We1_s">this website</a>
        </p>
      </div>
    );
  }

  getInitColumns() {
    let columnsConfig = {};
    if (RespUtils.isTabletView()) {
      columnsConfig = {
            index: false, vpRank: true, name: false, badge1Ind: true, status: true, votingPower: true, 
            votingPowerPercentage: true, commission: true, valBond: false, 
            selfBond: true, selfBondPercentage: true, lsmDelegations: true, 
            strdDelegation: true, qckDelegation: true, pstakeDelegation: true, 
            valBondRemCapacity: true, hasEnoughValBond: false, minValBond: true};
    } else {
      columnsConfig = {
            index: false, vpRank: false, name: false, badge1Ind: false, status: true, votingPower: true, 
            votingPowerPercentage: true, commission: false, valBond: false, 
            selfBond: true, selfBondPercentage: true, lsmDelegations: false, 
            strdDelegation: false, qckDelegation: false, pstakeDelegation: false, 
            valBondRemCapacity: false, hasEnoughValBond: false, minValBond: false};
    }

    // console.log("interchain val perf - getInit - columns config is: ", columnsConfig);
    return columnsConfig;
  }

  isHidden(dataField) {
    return UITableUtils.isHidden(key, dataField, this.getInitColumns);
  }

  repaintData() {
    let validators = this.state.validators;
    let newValidators = Utilities.addIndex(validators, "poolId");
    this.setState({validators: newValidators});
  }

  // renderSwitch() {
  //   // console.log(this.props);
  //   if (this.props.match && this.props.match.params.showAll === 'true') {
  //     return (<a className="animLink" href={SessionUtils.getUrl("/lsm/false/" + this.state.lsp)}>Show Validators with LS Delegations</a>);
  //   }

  //   return (<a className="animLink" href={SessionUtils.getUrl("/lsm/true/" + this.state.lsp)}>Show All Validators</a>);
  // }

  handleChartUpdateNetwork(frequencyNetwork) {
    let lsp = this.state.lsp;
    // let showAll = this.state.showAll;
    // this.prepareData(frequencyNetwork, showAll, lsp, false);
    this.prepareData(frequencyNetwork, lsp);
  }

  switchProtocol(e) {
    console.log(e.target.value);
    // if (e.target.value != this.state.lsp) {
    let lsp = e.target.value;
    // let showAll = this.state.showAll;
    // this.prepareData(this.state.frequencyNetwork, showAll, lsp, false);
    this.prepareData(this.state.frequencyNetwork, lsp);
    // }
  }

  renderFilters() {
    return (<div><table><tbody><tr>
        {ValidatorUtils.renderBadge(currentNetwork.details.ui.badges.badge1Ind, "/lsm/" + currentNetwork.details.ui.badges.badge1Key, 
          "Click to filter validator list for this provider", currentNetwork.details.ui.badges.badge1IndImg)}
        {ValidatorUtils.renderBadge(currentNetwork.details.ui.badges.badge2Ind, "/lsm/" + currentNetwork.details.ui.badges.badge2Key, 
          "Click to filter validator list for this provider", currentNetwork.details.ui.badges.badge2IndImg)}
        {ValidatorUtils.renderBadge(currentNetwork.details.ui.badges.badge3Ind, "/lsm/" + currentNetwork.details.ui.badges.badge3Key, 
          "Click to filter validator list for this provider", currentNetwork.details.ui.badges.badge3IndImg)}
      </tr></tbody></table></div>);
  }
}

export default LSM;
